<template lang="pug">
  .DisclaimerDisclosure.disclosure
    slot
    a(
      :class="linkClass",
      @click.prevent="setModalDisclaimerDisclosure()",
    )
      slot(name="linkName")
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DisclaimerDisclosure',
  props: {
    linkClass: String,
  },
  methods: {
    ...mapActions('modal', [
      'setModalDisclaimerDisclosure',
    ]),
  },
};
</script>
